module.exports = [
    { name: 'Aguascaliente' },
    { name: 'Baja Californa' },
    { name: 'Baja California Sur' },
    { name: 'Campeche' },
    { name: 'Chiapas' },
    { name: 'Chihuahua' },
    { name: 'Coahuila' },
    { name: 'Colima' },
    { name: 'DF' },
    { name: 'Durango' },
    { name: 'Guanajuato' },
    { name: 'Guerrero' },
    { name: 'Hidalgo' },
    { name: 'Jalisco' },
    { name: 'Estado de México' },
    { name: 'Michoacan' },
    { name: 'Morelos' },
    { name: 'Nayarit' },
    { name: 'Nuevo León' },
    { name: 'Oaxaca' },
    { name: 'Puebla' },
    { name: 'Querétaro' },
    { name: 'Quintana Roo' },
    { name: 'San Luis Potosi' },
    { name: 'Sinaloa' },
    { name: 'Sonora' },
    { name: 'Tabasco' },
    { name: 'Tamaulipas' },
    { name: 'Tlaxcala' },
    { name: 'Veracruz' },
    { name: 'Yucatán' }
]



// WEBPACK FOOTER //
// ./src/data/mexico_states.js